<template>
	<v-row>
		<v-col cols='12' class='pb-0'>
			<v-row no-gutters>
				<v-col cols='4' class='header-row'>
					<v-img
						class='mx-auto my-auto'
						width='250'
						height='100%'
						:src="require('assets/static/img/logo/fastpaytv_white.png')"
					/>
					<v-img id='star-1' width='40' height='40'
								 :src="require('@homepage/components/pageStyles/fastPayTv/images/estrella1.png')" />
				</v-col>
				<v-col cols='4' class='header-row'>
					<v-row class='h-100' align='center' no-gutters>
						<v-col cols='6' class='text-center'>PICKS</v-col>
						<v-col cols='6' class='text-center'>NUMBERS</v-col>
					</v-row>
				</v-col>
				<v-col cols='4' class='header-row'>
					<v-row class='h-100' no-gutters justify='center' align='center'>
						<v-col cols='auto' class='text-center'>PAYOUTS</v-col>
					</v-row>
				</v-col>
			</v-row>
		</v-col>
		<v-col cols='12' class='pt-0'>
			<v-row no-gutters>
				<v-col cols='4' class='content-column gray--bg'>
					<v-row no-gutters>
						<v-col cols='12'>
							<countdown px-5 py-5 text-center :sortition='generalInformation.sortition'>
								<template #default='{sortition}'>
									<v-flex md3>
										<h1 class='font-weight-bold text-uppercase'>Next draw in</h1>
									</v-flex>
									<v-flex md3>
										<h2 id='next-sortition' class='font-weight-bold'>{{ sortition.name }}</h2>
									</v-flex>
									<v-flex md3>
								<span id='time-left' v-if='sortition.timeLeft'
											class='font-weight-black text-uppercase'>{{ sortition.timeLeft }}</span>
										<span v-else><font-awesome-icon icon='sync' spin size='3x'></font-awesome-icon></span>
									</v-flex>
								</template>
							</countdown>
						</v-col>
					</v-row>
					<div class='text-center text-h4'><span>Winning Numbers</span></div>
					<result-display
						v-for='result in generalInformation.results.slice(0, 1)'
						:key='result.sortition.id'
						:result='result'
					>
					</result-display>
					<v-img id='floating-logo' height='140' width='140'
								 :src="require('@/assets/img/fastpaytv/logo.png')" />
				</v-col>
				<v-col cols='4' class='content-column white--bg'>
					<v-row no-gutters>
						<v-col cols='12'>
							<result-display
								v-for='result in generalInformation.results.slice(1, 3)'
								:key='result.sortition.id'
								:result='result'
							>
							</result-display>
						</v-col>
					</v-row>
				</v-col>
				<v-col cols='4' class='content-column gray--bg'>
					<v-row>
						<v-col cols='12'>
							<card-presenter
								class='px-5 py-5'
								:time-per-page='[timeToShowPrizesPage, timeToShowResultsPage]'>
								<template #page-1>
									<prizes-list :general-information='generalInformation'>
										<template #prize-row='{prize}'>
											<v-col class='prize-row white--bg rounded-lg' cols='12'>
												<v-row no-gutters class='py-3'>
													<v-col class='prize-name text-center' cols='6'>
														{{ prize.name }} - 1X:
													</v-col>
													<v-col class='prize-amount text-center' cols='6'>
														{{ prize.amount }}
													</v-col>
												</v-row>
											</v-col>
										</template>
									</prizes-list>
								</template>
								<template #page-2>
									<v-card id='lottery-results' rounded='xl'>
										<lottery-result-auto-display
											:general-information='generalInformation'
											:entries-per-page='lotteryEntriesPerPage'
											:time-to-show-each-page='timeToShowEachLotteryResultPage'>
											<template #page='{ entries }'>
												<v-container class='px-0 py-0'>
													<lottery-result v-for='(entry, index) in entries'
																					class='lottery-result'
																					:class="{'rounded-b-xl': index === entries.length - 1}"
																					:show-pick-five='true'
																					:key='entry.name'
																					:lottery='entry'>
														<template #sortition-header='{sortition, icon, date}'>
															<span class='sortition-header'>
																<font-awesome-icon :icon='icon'></font-awesome-icon>
																{{ sortition.name }}: {{ date }}
															</span>
														</template>
													</lottery-result>
												</v-container>
											</template>
										</lottery-result-auto-display>
									</v-card>
								</template>
							</card-presenter>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
		</v-col>
		<v-col id='page-url' cols='12' class='text-center'>
			<span>Visit our page fastpaytv.com</span>
		</v-col>
	</v-row>
</template>

<script>
import ResultDisplay from '../pageStyles/fastPayTv/ResultDisplay.vue';
import CardPresenter from '@homepage/components/CardPresenter.vue';
import LotteryResultAutoDisplay from '@homepage/components/LotteryResultAutoDisplay.vue';
import LotteryResult from '@homepage/components/LotteryResult.vue';
import Countdown from '@homepage/components/Countdown.vue';
import PrizesList from '@homepage/components/PrizesList.vue';
import { generateImageMapFor } from '@homepage/helpers/image.js';

export default {
	name: 'FastPayBoard',
	components: {
		Countdown,
		LotteryResult,
		LotteryResultAutoDisplay,
		CardPresenter,
		ResultDisplay,
		PrizesList
	},
	props: {
		generalInformation: {
			type: Object,
			required: true
		}
	},
	provide() {
		return {
			imagesMap: generateImageMapFor('quickmoney'),
			generalInformation: this.generalInformation
		};
	},
	data() {
		return {
			timeToShowPrizesPage: 8000,
			timeToShowEachLotteryResultPage: 5000,
			lotteryEntriesPerPage: 2
		};
	},
	computed: {
		timeToShowResultsPage() {
			const timeToShowEachPage = this.timeToShowEachLotteryResultPage / 1000;

			return Math.ceil(this.generalInformation.lotteriesResultsEntries.length / this.lotteryEntriesPerPage) * timeToShowEachPage * 1000;
		}
	},
	beforeCreate() {
		this.$emit('change-style', { backgroundImage: require('@/assets/img/fastpaytv/background.jpg') });
	}
};
</script>

<style
	scoped
	lang='scss'>
@import '../pageStyles/fastPayTv/css/variables';

@font-face {
	font-family: "RobotoBlack";
	src: url("../../../../public/fonts/roboto-black-webfont.woff");
}

* {
	font-family: "RobotoBlack", "Liberation Sans Narrow", serif;
	color: $darkblue;
}

::v-deep .sortition-result {
	padding: 8px 0;
}

::v-deep .sortition-result:first-child {
	padding-top: 10px;
}

::v-deep .sortition-result:last-child {
	padding-bottom: 10px;
}

::v-deep #lottery-results {
	background-color: #3b3b3b;

	* {
		color: black;
	}
}

#star-1 {
	position: absolute;
}

#floating-logo {
	position: absolute;
	bottom: 0;
	left: 120px;
}

.header-row {
	height: 76px;
	background-color: $blue;
	font-size: 1.7rem;
	color: $darkblue;
}

#next-sortition {
	font-size: 2.5rem;
	line-height: 35px;
}

#time-left {
	font-weight: 700;
	font-size: 3.5rem;
	text-align: center;
	color: #00aeef;
}

.header-row:first-child {
	border-top-left-radius: 20px;
}

.header-row:last-child {
	border-top-right-radius: 20px;
}

.content-column:first-child {
	border-bottom-left-radius: 20px;
}

.content-column:last-child {
	border-bottom-right-radius: 20px;
}

.result-display {
	margin: 15px 0;
}

.sortition-header {
	font-size: 1.1rem;
}

//.v-card {
//	background-color: #3b3b3b;
//	color: $blue;
//	border-radius: 30px;
//
//	&:not(#primary-card) {
//		box-shadow: 8px 6px 20px 0 #07000080;
//	}
//}

//#winning-numbers-text {
//	line-height: 30px;
//	color: $darkblue;
//}
//
//
//.card-header {
//	color: $darkblue;
//	font-size: 1.7rem;
//	display: flex;
//	flex-direction: row;
//	justify-content: space-around;
//}

.prize-row {
	font-size: 1.6rem;
	line-height: 1.6rem;
	font-weight: 700;
}

.prize-amount {
	color: #00aeef;
	font-size: 1.9rem;
	font-family: "DonJose", "Liberation Sans Narrow", serif;
}

#page-url span {
	font-size: 1.4rem;
	color: $blue;
}

</style>
